import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StyledBlackInformationTypography } from "../../../../components/commonComponents/StyledComponents/styled";
import { Box } from "@mui/material";
import SectionsList from "./SectionsList";

const ArchivedWorkspaceSections = () => {
    const currentStateData = useSelector((state) => state.userSelections);
    const dispatchAction = useDispatch();

    return (
        <>
            <Box height={10} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0 }}>
                Changes made here apply across the entire workspace.
            </StyledBlackInformationTypography>
            <Box height={5} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                Archived sections cannot be added to new brand reports. However, they will still appear in older reports if they were marked as visible when those reports were published.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                If you want to edit an archived section, you need to recover the section first.
            </StyledBlackInformationTypography>
            <Box height={2} />
            <StyledBlackInformationTypography variant="body2" sx={{ marginLeft: 0, fontWeight: "normal" }}>
                You can also choose to permanently delete archived sections. Please note that this will remove them from all past reports, and the deletion cannot be undone.
            </StyledBlackInformationTypography>
            <Box height={10} />

            {/* --------- workspace sections list ----------- */}
            <Box height={10} />
            <SectionsList listType={"archived"} sectionType={"performance"} />

        </>
    );
};

export default ArchivedWorkspaceSections;
